import {useDebugValue} from 'react';

import {noop} from '../../../utils';

import {useEvents} from './';

const defaultEvents = {
    onSettingsChange: noop,
    onCurrentValuesChange: noop,
    onLatestValuesChange: noop,
    onCancel: noop,
    onClose: noop,
    onDateRangeChange: noop,
    onDateRangeClear: noop,
    onDisabledDayClick: noop,
    onFocus: noop,
    onOpen: noop,
    onSelectionModeChange: noop,
    onSubmit: noop
};

function useDatesEvents(props) {
    const {
        datesEvents: propsEvents
    } = props;

    const {
        events
    } = useEvents(defaultEvents, propsEvents);

    const result = {
        events
    };

    useDebugValue(result);

    return result;
}

export {useDatesEvents};
